import React, { useState } from "react";

export default function ATCPanel({ parsed, setParsed }) {
  const [jobTitle, setJobTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const runATC = async () => {
    if (!parsed) return alert("Import or Add Resume First!");
    if (!jobTitle.trim()) return alert("Please enter a target job title.");

    try {
      const resumeText = JSON.stringify(parsed, null, 2);
      setLoading(true);

      const res = await fetch("https://api.reignitespirit.com/api/resume/atc", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          resumeContent: resumeText,
          jobDescription: jobTitle, // keep API field name if backend expects this
        }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || "ATC Failed");

      setResult(data);

      // OPTIONAL: auto inject back into editor
      setParsed((prev) => ({
        ...prev,
        targetTitle: data.tailored_title ?? prev.targetTitle,
        summary: data.tailored_summary ?? prev.summary,
        skills: Array.isArray(data.tailored_skills) ? data.tailored_skills : prev.skills,
        experience: Array.isArray(data.tailored_experience)
          ? data.tailored_experience
          : prev.experience,
      }));
    } catch (err) {
      alert(err.message || "ATC Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 bg-black/20 mt-6 rounded-xl border border-white/10">
      <h2 className="text-xl text-[#EB6AB5] font-bold mb-2">
        🎯 Target Job Title
      </h2>

      <input
        type="text"
        placeholder="e.g., Full Stack Developer"
        value={jobTitle}
        onChange={(e) => setJobTitle(e.target.value)}
        className="w-full p-3 rounded-lg bg-black border border-white/10"
      />

      <button
        type="button"
        onClick={runATC}
        className="w-full px-5 py-3 bg-gradient-to-r from-[#EB6AB5] to-[#ff83d1]
          text-[#0F0A24] font-bold rounded-xl mt-3 hover:opacity-95 transition"
      >
        {loading ? "Optimizing..." : "⚡ Generate / Regenerate Optimized Resume"}
      </button>

      {result && (
        <div className="mt-6 p-4 bg-black/40 rounded-xl border border-white/10">
          <h3 className="text-[#EB6AB5] font-bold text-lg">
            Optimized Output Preview
          </h3>

          <p className="mt-2">
            <strong>Title:</strong> {result.tailored_title}
          </p>

          <p className="mt-2">
            <strong>Summary:</strong> {result.tailored_summary}
          </p>

          <p className="mt-3">
            <strong>ATS Match Score:</strong>{" "}
            <span className="ml-2 px-3 py-1 rounded-full bg-[#EB6AB5]/20 text-[#EB6AB5] font-bold">
              {result.match_score}
            </span>
          </p>

          {Array.isArray(result.tailored_skills) && result.tailored_skills.length > 0 && (
            <>
              <h4 className="mt-4 font-bold">Skills:</h4>
              <ul className="ml-5 list-disc mt-2">
                {result.tailored_skills.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  );
}